/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccesoDenegado as AccesoDenegado,
  rec_Componente_hA_104_65 as Componente_hA_104_65,
  rec_DesempenoPersonal as DesempenoPersonal,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_Rr as Rr,
  rec_SelectorFecha as SelectorFecha,
  rec_SelectorMultiple as SelectorMultiple,
  rec_TransferirTrabajo as TransferirTrabajo,
  rec_Zi as Zi,
  rec_api as api,
  rec_bA as bA,
  rec_puedeRutaAdmin as puedeRutaAdmin,
  rec_ii as ii,
  rec_pA as pA,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function Personal() {
  let e = puedeRutaAdmin(`/admin/personal`),
    [t, n] = (0, React.useState)(() => pA(new Date())),
    [r, i] = (0, React.useState)([]),
    [a, o] = (0, React.useState)(!0),
    [s, c] = (0, React.useState)(``),
    [l, u] = (0, React.useState)(null),
    [f, p] = (0, React.useState)(null),
    [m, h] = (0, React.useState)([]),
    [g, _] = (0, React.useState)(null),
    v = (0, React.useCallback)(async () => {
      (o(!0),
        api(`/personal/ausentes`, {
          sinCache: !0,
        })
          .then((e) => h(e ?? []))
          .catch(() => h([])));
      try {
        (i(await api(`/personal?desde=${t.desde}&hasta=${t.hasta}`)), c(``));
      } catch (e) {
        c(e.message);
      } finally {
        o(!1);
      }
    }, [t]);
  (0, React.useEffect)(() => {
    v();
  }, [v]);
  let y = (0, React.useMemo)(
      () =>
        [...new Set(r.map((e) => e.area).filter(Boolean))].sort((e, t) =>
          e.localeCompare(t),
        ),
      [r],
    ),
    [b, x] = (0, React.useState)(``),
    S = b ? r.filter((e) => e.area === b) : r;
  if (!e) return <AccesoDenegado />;
  function C() {
    let e = [
        [
          `Persona`,
          `Área`,
          `Cargo`,
          `Debía entregar`,
          `Entregó`,
          `A tiempo`,
          `Tarde`,
          `Días de atraso`,
          `Abiertas`,
          `Vencidas`,
          `Devoluciones`,
          `Replanificadas`,
          `Por tardanza`,
          `Cumplimiento %`,
          `Puntualidad %`,
          `Aprobó`,
          `Horas en aprobar`,
          `Sin aprobar`,
          `Demoradas`,
        ],
        ...S.map((e) => [
          e.nombre,
          e.area ?? ``,
          e.cargo ?? ``,
          e.asignadas,
          e.completadas,
          e.aTiempo,
          e.tarde,
          e.diasAtrasoPromedio,
          e.abiertas,
          e.vencidas,
          e.devoluciones,
          e.prorrogasReprogramacion,
          e.prorrogasTardanza,
          e.cumplimiento,
          e.puntualidad,
          e.conformidadesDadas,
          e.horasPromedioAprobar,
          e.esperandoSuConformidad,
          e.conformidadesDemoradas,
        ]),
      ].map((e) => e.map((e) => `"${String(e).replace(/"/g, `""`)}"`).join(`;`))
        .join(`
`),
      n = URL.createObjectURL(
        new Blob([`﻿` + e], {
          type: `text/csv;charset=utf-8`,
        }),
      ),
      r = document.createElement(`a`);
    ((r.href = n),
      (r.download = `personal-${t.desde}-a-${t.hasta}.csv`),
      r.click(),
      URL.revokeObjectURL(n));
  }
  return (
    <EstructuraPrincipal
      title={`Personal`}
      children={[
        <div
          className={`flex flex-col gap-4`}
          children={[
            <div
              className={`flex flex-wrap items-end justify-between gap-2`}
              children={[
                <p
                  className={`text-sm text-(--text)`}
                  children={[
                    `Lo que cada persona `,
                    <strong
                      className={`text-(--text-h)`}
                      children={`tenía que entregar`}
                    />,
                    ` en el período, y cuánto de eso llegó en fecha.`,
                  ]}
                />,
                <div
                  className={`flex flex-wrap items-center gap-2`}
                  children={[
                    <div
                      className={`w-36`}
                      children={
                        <SelectorFecha
                          value={t.desde}
                          placeholder={`Desde`}
                          onChange={(e) =>
                            n((t) => ({
                              ...t,
                              desde: e,
                            }))
                          }
                        />
                      }
                    />,
                    <div
                      className={`w-36`}
                      children={
                        <SelectorFecha
                          value={t.hasta}
                          placeholder={`Hasta`}
                          min={t.desde}
                          onChange={(e) =>
                            n((t) => ({
                              ...t,
                              hasta: e,
                            }))
                          }
                        />
                      }
                    />,
                    y.length > 0 && (
                      <div
                        className={`w-52`}
                        children={
                          <SelectorMultiple
                            value={b}
                            onChange={x}
                            placeholder={`Todas las áreas`}
                            opciones={y.map((e) => ({
                              value: e,
                              label: e,
                            }))}
                          />
                        }
                      />
                    ),
                    <button
                      type={`button`}
                      onClick={C}
                      className={zo}
                      children={[
                        <Rr className={`mr-1 inline h-3.5 w-3.5`} />,
                        ` Exportar`,
                      ]}
                    />,
                  ]}
                />,
              ]}
            />,
            <EstadoError mensaje={s} onReintentar={v} />,
            m.length > 0 && (
              <section
                className={`flex flex-col gap-2 rounded-2xl border border-(--warning) bg-(--warning)/10 p-3`}
                children={[
                  <p
                    className={`text-sm font-medium text-(--text-h)`}
                    children={
                      m.length === 1
                        ? `Alguien que ya no está dejó cosas a su nombre`
                        : `${m.length} personas que ya no están dejaron cosas a su nombre`
                    }
                  />,
                  <ul
                    className={`flex flex-col divide-y divide-(--border)`}
                    children={m.map((e) => (
                      <li
                        key={e.usuarioId}
                        className={`flex flex-wrap items-center justify-between gap-2 py-2`}
                        children={[
                          <span
                            className={`min-w-0 text-sm`}
                            children={[
                              <strong
                                className={`text-(--text-h)`}
                                children={e.nombre}
                              />,
                              <span
                                className={`text-(--text)`}
                                children={[` · `, bA(e.resumen)]}
                              />,
                            ]}
                          />,
                          <button
                            type={`button`}
                            onClick={() => _(e)}
                            className={`${zo} min-h-11`}
                            children={`Pasar lo que dejó`}
                          />,
                        ]}
                      />
                    ))}
                  />,
                ]}
              />
            ),
            a ? (
              <div
                className={`flex items-center gap-2 text-sm text-(--text)`}
                children={[
                  (0, JSXRuntime.jsx)(ii, {
                    className: `h-4 w-4 animate-spin`,
                  }),
                  ` Cargando…`,
                ]}
              />
            ) : (
              <JSXRuntime.Fragment
                children={[
                  <ul
                    className={`flex flex-col gap-2 sm:hidden`}
                    children={[
                      S.map((e) => (
                        <li
                          key={e.usuarioId}
                          className={`rounded-xl border border-(--border) p-3`}
                          children={[
                            <div
                              className={`flex items-start justify-between gap-2`}
                              children={[
                                <button
                                  type={`button`}
                                  onClick={() => u(e.usuarioId)}
                                  className={`min-w-0 flex-1 text-left`}
                                  children={[
                                    <span
                                      className={`block truncate font-medium text-(--text-h)`}
                                      children={e.nombre}
                                    />,
                                    <span
                                      className={`block truncate text-xs text-(--text)`}
                                      children={e.area ?? `Sin área`}
                                    />,
                                  ]}
                                />,
                                <button
                                  type={`button`}
                                  onClick={() => p(e)}
                                  aria-label={`Dar de baja a ${e.nombre}`}
                                  className={`shrink-0 rounded-lg p-2 text-(--text) hover:bg-(--error-bg) hover:text-(--error)`}
                                  children={<Zi className={`h-4 w-4`} />}
                                />,
                              ]}
                            />,
                            <div
                              className={`mt-2 grid grid-cols-2 gap-3`}
                              children={[
                                <div
                                  children={[
                                    <p
                                      className={`text-[11px] text-(--text)`}
                                      children={`Entregó`}
                                    />,
                                    <Componente_hA_104_65
                                      valor={e.cumplimiento}
                                    />,
                                  ]}
                                />,
                                <div
                                  children={[
                                    <p
                                      className={`text-[11px] text-(--text)`}
                                      children={`En fecha`}
                                    />,
                                    <Componente_hA_104_65
                                      valor={e.puntualidad}
                                      alerta={e.tarde > 0}
                                    />,
                                  ]}
                                />,
                              ]}
                            />,
                            <p
                              className={`mt-2 flex flex-wrap gap-x-3 text-xs text-(--text)`}
                              children={[
                                <span
                                  children={[
                                    e.completadas,
                                    ` de `,
                                    e.asignadas,
                                  ]}
                                />,
                                e.diasAtrasoPromedio > 0 && (
                                  <span
                                    className={`text-(--error)`}
                                    children={[
                                      e.diasAtrasoPromedio,
                                      ` d de atraso`,
                                    ]}
                                  />
                                ),
                                e.vencidas > 0 && (
                                  <span
                                    className={`text-(--error)`}
                                    children={[e.vencidas, ` vencidas`]}
                                  />
                                ),
                                e.conformidadesDemoradas > 0 && (
                                  <span
                                    className={`text-(--error)`}
                                    children={[
                                      e.conformidadesDemoradas,
                                      ` sin aprobar`,
                                    ]}
                                  />
                                ),
                              ]}
                            />,
                          ]}
                        />
                      )),
                      S.length === 0 && (
                        <li
                          className={`rounded-xl border border-dashed border-(--border) px-3 py-6 text-center text-sm text-(--text)`}
                          children={`No hay personal para ese filtro.`}
                        />
                      ),
                    ]}
                  />,
                  <div
                    className={`hidden overflow-x-auto rounded-2xl border border-(--border) sm:block`}
                    children={
                      <table
                        className={`w-full min-w-[880px] text-sm tabular-nums`}
                        children={[
                          <thead
                            children={
                              <tr
                                className={`border-b border-(--border) bg-(--panel) text-left text-xs text-(--text)`}
                                children={[
                                  <th
                                    className={`px-3 py-2 font-normal`}
                                    children={`Persona`}
                                  />,
                                  <th
                                    className={`px-3 py-2 font-normal`}
                                    children={`Área`}
                                  />,
                                  <th
                                    className={`px-3 py-2 text-right font-normal`}
                                    children={`Debía`}
                                  />,
                                  <th
                                    className={`px-3 py-2 text-right font-normal`}
                                    children={`Entregó`}
                                  />,
                                  <th
                                    className={`px-3 py-2 font-normal`}
                                    children={`Cumplimiento`}
                                  />,
                                  <th
                                    className={`px-3 py-2 font-normal`}
                                    children={`En fecha`}
                                  />,
                                  <th
                                    className={`px-3 py-2 text-right font-normal`}
                                    children={`Atraso medio`}
                                  />,
                                  <th
                                    className={`px-3 py-2 text-right font-normal`}
                                    children={`Abiertas`}
                                  />,
                                  <th
                                    className={`px-3 py-2 text-right font-normal`}
                                    children={`Prórrogas`}
                                  />,
                                  <th className={`px-3 py-2`} />,
                                ]}
                              />
                            }
                          />,
                          <tbody
                            children={[
                              S.map((e) => (
                                <tr
                                  key={e.usuarioId}
                                  className={`border-b border-(--border)/60`}
                                  children={[
                                    <td
                                      className={`px-3 py-2`}
                                      children={[
                                        <button
                                          type={`button`}
                                          onClick={() => u(e.usuarioId)}
                                          className={`text-left text-(--text-h) hover:text-(--accent) hover:underline`}
                                          children={e.nombre}
                                        />,
                                        e.cargo && (
                                          <p
                                            className={`text-xs text-(--text)`}
                                            children={e.cargo}
                                          />
                                        ),
                                        e.conformidadesDemoradas > 0 && (
                                          <p
                                            className={`text-xs text-(--error)`}
                                            children={[
                                              e.conformidadesDemoradas,
                                              ` sin aprobar hace días`,
                                            ]}
                                          />
                                        ),
                                      ]}
                                    />,
                                    <td
                                      className={`max-w-[220px] px-3 py-2`}
                                      children={
                                        <span
                                          className={`block truncate text-xs text-(--text)`}
                                          title={e.area}
                                          children={e.area ?? `—`}
                                        />
                                      }
                                    />,
                                    <td
                                      className={`px-3 py-2 text-right text-(--text-h)`}
                                      children={e.asignadas}
                                    />,
                                    <td
                                      className={`px-3 py-2 text-right text-(--text-h)`}
                                      children={e.completadas}
                                    />,
                                    <td
                                      className={`px-3 py-2`}
                                      children={
                                        <Componente_hA_104_65
                                          valor={e.cumplimiento}
                                        />
                                      }
                                    />,
                                    <td
                                      className={`px-3 py-2`}
                                      children={
                                        <Componente_hA_104_65
                                          valor={e.puntualidad}
                                          alerta={e.tarde > 0}
                                        />
                                      }
                                    />,
                                    <td
                                      className={`px-3 py-2 text-right ${e.diasAtrasoPromedio > 0 ? `text-(--error)` : `text-(--text)`}`}
                                      children={
                                        e.diasAtrasoPromedio > 0
                                          ? `${e.diasAtrasoPromedio} d`
                                          : `—`
                                      }
                                    />,
                                    <td
                                      className={`px-3 py-2 text-right`}
                                      children={[
                                        <span
                                          className={`text-(--text-h)`}
                                          children={e.abiertas}
                                        />,
                                        e.vencidas > 0 && (
                                          <span
                                            className={`ml-1 text-xs text-(--error)`}
                                            children={[
                                              `(`,
                                              e.vencidas,
                                              ` vencidas)`,
                                            ]}
                                          />
                                        ),
                                      ]}
                                    />,
                                    <td
                                      className={`px-3 py-2 text-right text-xs text-(--text)`}
                                      children={
                                        e.prorrogasTardanza +
                                          e.prorrogasReprogramacion ===
                                        0 ? (
                                          `—`
                                        ) : (
                                          <JSXRuntime.Fragment
                                            children={[
                                              e.prorrogasTardanza > 0 && (
                                                <span
                                                  className={`text-(--warning)`}
                                                  children={[
                                                    e.prorrogasTardanza,
                                                    ` tardanza`,
                                                  ]}
                                                />
                                              ),
                                              e.prorrogasTardanza > 0 &&
                                                e.prorrogasReprogramacion > 0 &&
                                                ` · `,
                                              e.prorrogasReprogramacion > 0 && (
                                                <span
                                                  children={[
                                                    e.prorrogasReprogramacion,
                                                    ` replan.`,
                                                  ]}
                                                />
                                              ),
                                            ]}
                                          />
                                        )
                                      }
                                    />,
                                    <td
                                      className={`px-3 py-2 text-right`}
                                      children={
                                        <button
                                          type={`button`}
                                          onClick={() => p(e)}
                                          aria-label={`Dar de baja a ${e.nombre}`}
                                          title={`Dar de baja y pasar su trabajo`}
                                          className={`rounded-lg p-1 text-(--text) hover:bg-(--error-bg) hover:text-(--error)`}
                                          children={
                                            <Zi className={`h-4 w-4`} />
                                          }
                                        />
                                      }
                                    />,
                                  ]}
                                />
                              )),
                              S.length === 0 && (
                                <tr
                                  children={
                                    <td
                                      colSpan={10}
                                      className={`px-3 py-6 text-center text-sm text-(--text)`}
                                      children={`No hay personal para ese filtro.`}
                                    />
                                  }
                                />
                              ),
                            ]}
                          />,
                        ]}
                      />
                    }
                  />,
                ]}
              />
            ),
          ]}
        />,
        l && (
          <DesempenoPersonal
            usuarioId={l}
            rango={t}
            onClose={() => u(null)}
            onCambio={v}
          />
        ),
        f && (
          <TransferirTrabajo
            persona={f}
            onClose={() => p(null)}
            onHecho={() => {
              (p(null), v());
            }}
          />
        ),
        g && (
          <TransferirTrabajo
            yaSeFue={!0}
            persona={g}
            onClose={() => _(null)}
            onHecho={() => {
              (_(null), v());
            }}
          />
        ),
      ]}
    />
  );
}
